import { render, staticRenderFns } from "./BusTimetable.vue?vue&type=template&id=4ab64550&scoped=true"
import script from "./BusTimetable.vue?vue&type=script&lang=js"
export * from "./BusTimetable.vue?vue&type=script&lang=js"
import style0 from "./BusTimetable.vue?vue&type=style&index=0&id=4ab64550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab64550",
  null
  
)

export default component.exports